export default {"src":"/_next/static/media/jd-KneeLength.818a61c9.svg","height":150,"width":63,"blurWidth":0,"blurHeight":0};